import axios from 'axios'
// import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: 'https://2d.hep.com.cn', // api的base_url
  // baseURL: 'http://localhost:4030', // api的base_url
  timeout: 100000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    let pToken = getToken()
    if (pToken) {
      config.headers['x-access-token'] = pToken
    }

    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// respone interceptor
service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res) {
      return response.data
    }
    return Promise.reject(new Error('error'))
  },
  error => {
    console.log('redirect error', error)
    if (error.response && error.response.status === 401) {
      console.log('redirect')
      window.location.href = 'https://2d.hep.com.cn/auth/wechat-slient?redirectUrl=' + window.location.href
    }
    return Promise.reject(error)
  }
)

export default service
